/* unplugin-vue-components disabled */import { render } from "./RealNameGuide.vue?vue&type=template&id=4db8b114&scoped=true"
import script from "./RealNameGuide.vue?vue&type=script&lang=js"
export * from "./RealNameGuide.vue?vue&type=script&lang=js"

import "./RealNameGuide.vue?vue&type=style&index=0&id=4db8b114&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db8b114"]])

export default __exports__